// export const BASE_URL = "https://lms-backend-app.onrender.com/api/v1";
// export const BASE_URL = "https://lms-be-v2-production.up.railway.app/api/v1";
// export const BASE_URL = "https://lms-backend-new-acabd3f70609.herokuapp.com/api/v1";
// export const BASE_URL = "https://byshelbserver2-9notreal125b1.herokuapp.com/api/v1";
// export const BASE_URL = "https://byshelbserver2-9306452125b1.herokuapp.com/api/v1";
// export const BASE_URL = "https://lms-be-v2.onrender.com/api/v1";
export const BASE_URL = process.env.REACT_APP_BASE_URL;
